export enum EvaluationActionTypes {
  GET_EVAL_RUNS = "@@EVALUATION/GET_EVAL_RUNS",
  GET_EVAL_RUNS_SUCCESS = "@@EVALUATION/GET_EVAL_RUNS_SUCCESS",
  GET_EVAL_RUNS_FAILURE = "@@EVALUATION/GET_EVAL_RUNS_FAILURE",

  GET_EVAL_RUN = "@@EVALUATION/GET_EVAL_RUN",
  GET_EVAL_RUN_SUCCESS = "@@EVALUATION/GET_EVAL_RUN_SUCCESS",
  GET_EVAL_RUN_FAILURE = "@@EVALUATION/GET_EVAL_RUN_FAILURE",

  SUBMIT_EVAL_RUN = "@@EVALUATION/SUBMIT_EVAL_RUN",
  SUBMIT_EVAL_RUN_SUCCESS = "@@EVALUATION/SUBMIT_EVAL_RUN_SUCCESS",
  SUBMIT_EVAL_RUN_FAILURE = "@@EVALUATION/SUBMIT_EVAL_RUN_FAILURE",

  DELETE_EVAL_RUN = "@@EVALUATION/DELETE_EVAL_RUN",
  DELETE_EVAL_RUN_SUCCESS = "@@EVALUATION/DELETE_EVAL_RUN_SUCCESS",
  DELETE_EVAL_RUN_FAILURE = "@@EVALUATION/DELETE_EVAL_RUN_FAILURE",

  GET_EVAL_DATASETS = "@@EVALUATION/GET_EVAL_DATASETS",
  GET_EVAL_DATASETS_SUCCESS = "@@EVALUATION/GET_EVAL_DATASETS_SUCCESS",
  GET_EVAL_DATASETS_FAILURE = "@@EVALUATION/GET_EVAL_DATASETS_FAILURE",

  SET_FILTER = "@@EVALUATION/SET_FILTER",
  CLEAR_EVAL_RUN = "@@EVALUATION/CLEAR_EVAL_RUN",
  CLEAR_EVAL_RUNS = "@@EVALUATION/CLEAR_EVAL_RUNS",
}
